import axios, {
  type AxiosResponse,
  type InternalAxiosRequestConfig,
} from "axios";
import { createNotification } from "@/tools/notification";
import { useUser } from "@/stores/user/user";
import { useGuest } from "@/stores/auth/guest";

export const API_URL = "https://swagger.baskit.ru/api";

export const sessionKeyRequestInterceptor = async (
  config: InternalAxiosRequestConfig<any>,
) => {
  // Authorization is now handled by http-only cookies, which are automatically sent by the browser
  // when withCredentials: true is set on the axios instance.
  return config;
};

export const fulFilledResponseInterceptor = (response: AxiosResponse) =>
  response;

export const rejectedResponseInterceptor = async (error: any) => {
  const originalRequest = error.config;
  if (
    error.response &&
    !originalRequest.url?.includes("refreshToken") &&
    (error.response.status === 401 || error.response.status === 403) &&
    (typeof error.response.data !== "object" || error.response.data === null)
  ) {
    const userStore = useUser();
    const guestStore = useGuest();
    await guestStore.authLikeGuest();
    const response = await userStore.refreshAuth();

    if (response) {
      // Retry the original request. The refreshAuth call should have updated the http-only cookies.
      return ApiInstance(originalRequest);
    } else {
      if (userStore.userIsLoggined) {
        await userStore.logout();

        createNotification("error", "Сессия истекла, авторизуйтесь заново");

        window.location.href = "/login";
      }
    }
  }

  throw error;
};

export const ApiInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

ApiInstance.interceptors.request.use(sessionKeyRequestInterceptor);

ApiInstance.interceptors.response.use(
  fulFilledResponseInterceptor,
  rejectedResponseInterceptor,
);
